// @flow
import * as React from 'react'
import moment from 'moment'
import { FormattedMoment } from 'mz-intl'
import Input from 'mz-ui-kit/core/Input'
import { isIOS } from 'mz-ui-kit/utils'
import CalendarIcon from 'mz-icons/calendar'

// Types
import type Moment from 'moment'
import { getDateFormat } from '../utils'
import { InputContainer, NativeInput } from './elements'
import BaseField from '../../../core/BaseField'
import type { Props as BaseFieldProps } from '../../../core/BaseField'

export type Props = BaseFieldProps

type State = {
  date: string,
  value: Moment,
}

const NATIVE_DATE_FORMAT = 'YYYY-MM-DD'

class MobileNativeDateField extends React.Component<Props, State> {
  static defaultProps = {
    input: {},
    meta: {},
  }

  state = {
    date: '',
    value: null,
  }

  componentDidMount() {
    this.initValue(this.props)
  }

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    if (nextProps.input.value !== this.props.input.value) {
      this.initValue(nextProps)
    }
  }

  initValue(props: Props) {
    const {
      input: { value },
    } = props

    this.setState({
      date: value ? value.format(NATIVE_DATE_FORMAT) : '',
      value: value || null,
    })
  }

  handleOnChange = (event: Object) => {
    const {
      input: { value: prevValue, onChange },
    } = this.props
    const newValue = event.target.value

    // Ignore empty value that could be produced by iOS Done/Clear buttons
    if (!newValue) return

    const newMomentDate = newValue
      ? moment(newValue, NATIVE_DATE_FORMAT)
      : moment()

    const momentDateTime = (prevValue || newMomentDate)
      .clone()
      .year(newMomentDate.year())
      .month(newMomentDate.month())
      .date(newMomentDate.date())

    this.setState({
      date: newMomentDate.format(NATIVE_DATE_FORMAT),
      value: momentDateTime,
    })

    if (!isIOS()) {
      onChange && onChange(momentDateTime)
    }
  }

  handleOnBlur = () => {
    const {
      input: { onChange, onBlur },
    } = this.props

    if (isIOS()) {
      onChange && onChange(this.state.value)
    }

    onBlur && onBlur()
  }

  renderInput = ({
    input: { value, onFocus },
    style,
    props: { dateFormat, disableTime, ...props },
  }: any) => {
    const { id, ...rest } = props

    return (
      <InputContainer>
        <FormattedMoment
          value={value}
          format={getDateFormat(disableTime, dateFormat)}
        >
          {(valueStr) => (
            <Input
              tabIndex={-1}
              props={rest}
              style={style}
              input={{ value: valueStr }}
            />
          )}
        </FormattedMoment>
        <NativeInput
          id={id}
          type="date"
          value={this.state.date}
          onChange={this.handleOnChange}
          onFocus={onFocus}
          onBlur={this.handleOnBlur}
        />
      </InputContainer>
    )
  }

  render() {
    return (
      <BaseField
        {...this.props}
        renderInput={this.renderInput}
        renderPrefix={() => <CalendarIcon />}
        type="static"
        selectable
        emptyValue={null}
      />
    )
  }
}

export default MobileNativeDateField
